export default __webpack_public_path__ + "static/media/email-grey.00d4d6aa.svg";